const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-medical-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-heading font-semibold mb-4">About Us</h1>
          <p className="text-white/90">Your trusted partner in medical supplies</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
          <img
            src="https://images.pexels.com/photos/9574339/pexels-photo-9574339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Medical professionals"
            className="w-full rounded-lg mb-8 shadow-md"
          />

          <div className="prose max-w-none">
            <h2 className="text-3xl font-heading font-semibold mb-6 text-gray-900">Our Mission</h2>
            
            <p className="text-gray-600 leading-relaxed mb-6">
              MEDICAL SUPPLY AND MORE is dedicated to providing affordable, high-quality medical supplies to healthcare providers and individuals. Our mission is to ensure reliable access to essential healthcare products with fast delivery and exceptional service.
            </p>

            <h3 className="text-2xl font-heading font-semibold mb-4 text-gray-900">Who We Serve</h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              We proudly serve a diverse range of customers including:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
              <li>Clinics and medical practices</li>
              <li>Small hospitals and healthcare facilities</li>
              <li>Professional caregivers</li>
              <li>Home care providers</li>
              <li>Individual customers with medical needs</li>
            </ul>

            <h3 className="text-2xl font-heading font-semibold mb-4 text-gray-900">Our Commitment</h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              We understand the critical importance of reliable medical supplies in healthcare delivery. That's why we maintain:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
              <li>Stringent quality control standards</li>
              <li>Competitive and transparent pricing</li>
              <li>Fast and reliable shipping</li>
              <li>Exceptional customer service</li>
              <li>Special pricing for bulk orders</li>
            </ul>

            <div className="bg-medical-accent p-6 rounded-lg mt-8">
              <p className="text-gray-700 italic">
                "At Medical Supply and More, we don't just supply products – we build partnerships with our customers to support better healthcare outcomes for everyone."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;